import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useCampaign } from '../../contexts/CampaignContext/useCampaign';
import { useSlideUpVariants } from '../../hooks/useSlideUpVariants';
import { createKeyboardActivationHandler } from '../../utils/keyboardActivation';
import './style.less';

export const ServiceCard = ({
  icon,
  title,
  description,
  delay = 0,
  onClick,
  serviceId,
  isPackage = false,
}) => {
  const { t } = useTranslation();

  // Check if service has a discount (for badge display)
  const { isCampaignActive, hasServiceDiscount, getDiscountPercent } = useCampaign();
  const showBadge = isCampaignActive && hasServiceDiscount(serviceId);
  const badgePercent = getDiscountPercent(serviceId);
  const isFree = badgePercent === 100;

  const variants = useSlideUpVariants(delay);

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const handleKeyDown = createKeyboardActivationHandler(() => {
    if (onClick) {
      onClick();
    }
  });

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={variants}
      className={`service-card ${onClick ? 'clickable' : ''} ${isPackage ? 'package' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={onClick ? 0 : undefined}
      role={onClick ? 'button' : undefined}
      aria-label={onClick ? `View details for ${title}` : undefined}
    >
      {showBadge && badgePercent > 0 && (
        <div className={`discount-badge ${isFree ? 'free' : ''}`}>
          <i className="fas fa-tag"></i>
          <span className="discount-value">
            {isFree ? t('campaign.free') : `-${badgePercent}%`}
          </span>
        </div>
      )}
      <div className="service-icon">
        <i className={`fas ${icon}`}></i>
      </div>
      <h3>{title}</h3>
      {description && <p>{description}</p>}
      {onClick && (
        <div className="card-hover-indicator">
          <i className="fas fa-arrow-right"></i>
        </div>
      )}
    </motion.div>
  );
};
